var _rect, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNomeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 79 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.893555,
    width: 79,
    height: 79,
    rx: 39.5,
    fill: "#F6E003"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.5003,
    cy: 40.3939,
    r: 35.8792,
    stroke: "black",
    strokeWidth: 0.658333
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 52.183 57.416 L 49.803 54.77 L 49.803 55.738 L 47.48 55.738 L 47.48 52.189 L 24.244 26.361 L 25.905 24.516 L 53.844 55.571 L 52.183 57.416 Z M 49.803 47.387 L 47.445 44.767 L 47.445 43.373 L 46.191 43.373 L 43.416 40.288 L 43.416 31.86 C 43.416 29.786 44.014 28.085 45.21 26.755 C 46.406 25.426 47.937 24.761 49.803 24.761 L 49.803 47.387 Z M 39.816 36.326 L 37.494 33.706 L 37.494 24.761 L 39.816 24.761 L 39.816 36.326 Z M 35.52 31.511 L 33.197 28.93 L 33.197 24.761 L 35.52 24.761 L 35.52 31.511 Z M 31.223 26.736 L 29.447 24.761 L 31.223 24.761 L 31.223 26.736 Z M 33.197 55.738 L 33.197 41.515 C 31.997 41.205 30.981 40.512 30.149 39.437 C 29.317 38.361 28.901 37.083 28.901 35.603 L 28.901 27.846 L 31.223 30.427 L 31.223 35.603 L 33.197 35.603 L 33.197 32.622 L 35.531 35.203 L 35.531 35.59 L 35.88 35.59 L 38.899 38.959 C 38.512 39.604 38.026 40.149 37.442 40.592 C 36.857 41.035 36.216 41.343 35.52 41.515 L 35.52 55.738 L 33.197 55.738 Z",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNomeal);
export default __webpack_public_path__ + "static/media/nomeal.424b886f5b64e27019cfa6c1390fc427.svg";
export { ForwardRef as ReactComponent };